// @flow
import type { Request } from '../../index';


export const GET_FOOD_ITEMS_EXPORT: Request<void, void> = ['food/items/export', 'get', []];
